/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_LowerInputs */

const en_us2_profile_editors_split_lower = /** @type {(inputs: Profile_Editors_Split_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower body`)
};

const pt_br2_profile_editors_split_lower = /** @type {(inputs: Profile_Editors_Split_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferiores`)
};

const es_419_profile_editors_split_lower = /** @type {(inputs: Profile_Editors_Split_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tren inferior`)
};

const pt_pt2_profile_editors_split_lower = /** @type {(inputs: Profile_Editors_Split_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferiores`)
};

const fr_fr2_profile_editors_split_lower = /** @type {(inputs: Profile_Editors_Split_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas du corps`)
};

const de_de2_profile_editors_split_lower = /** @type {(inputs: Profile_Editors_Split_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterkörper`)
};

const it_it2_profile_editors_split_lower = /** @type {(inputs: Profile_Editors_Split_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte inferiore`)
};

/**
* | output |
* | --- |
* | "Lower body" |
*
* @param {Profile_Editors_Split_LowerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_lower = /** @type {((inputs?: Profile_Editors_Split_LowerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_LowerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_lower(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_lower(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_lower(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_lower(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_lower(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_lower(inputs)
	return en_us2_profile_editors_split_lower(inputs)
});
export { profile_editors_split_lower as "profile-editors.split_lower" }